import { Box, HStack } from '@chakra-ui/react'
import { FC, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import useAuth from '@hook/shared/use-auth'

import { ILink } from '@base/@types/components/Layout/Navigator'
import links from '@base/variables/shared/links'

import NavigatorTab from './Tab'
import NavigatorTabScheduler from './TabAgendamento'

interface INavLink extends ILink {
  active: boolean
}

const LayoutNavigator: FC = () => {
  const { pathname } = useLocation()

  const [navLinks, setNavLinks] = useState<INavLink[]>([])
  const { role, isSchedulling, userId } = useAuth()

  useEffect(() => {
    if (links[links.length - 1] === null) {
      links.pop()
    }
    setNavLinks(
      links.map(link => {
        if (link != null) {
          const active = link.path
            ? link.path === pathname
            : !!link.menu!.find((menu: any) => menu.path === pathname)

          return {
            ...link,
            active
          }
        }
      })
    )
  }, [pathname])
  return (
    <Box bg="#1d5840" height={16} paddingX={4}>
      <HStack
        maxW={996}
        spacing={35}
        marginX="auto"
        overflow="auto"
        justifyContent="start"
        transition="all ease .3s"
        boxSize="-moz-min-content"
        css={{
          '&::-webkit-scrollbar': {
            height: '8px',
            display: 'none'
          },
          '&::-webkit-scrollbar-track': {
            background: '#184835',
            marginBottom: '5px'
          },
          '&::-webkit-scrollbar-thumb': {
            borderRadius: '10px',
            background: '#3f6c5a',
            border: '1px solid #2e4f42',
            padding: '5px',
            marginBottom: '5px'
          }
        }}
        _hover={{
          '&::-webkit-scrollbar': {
            display: 'block'
          }
        }}
      >
        {navLinks.map((link, index) => (
          <>
            <>
              {link.group === 'Agendamento' ? (
                isSchedulling ? (
                  <NavigatorTabScheduler
                    id={`nav-link-${index + 1}`}
                    key={`navlink-${index + 1}`}
                    isLast={false}
                    isFirst={true}
                    {...link}
                  />
                ) : (
                  <></>
                )
              ) : (
                <></>
              )}
              {link.userIds ? (
                link.userIds.includes(userId) ? (
                  <NavigatorTab
                    id={`nav-link-${index + 1}`}
                    key={`navlink-${index + 1}`}
                    isLast={false}
                    isFirst={true}
                    {...link}
                  />
                ) : (
                  <></>
                )
              ) : link.roles ? (
                link.roles.includes(role) && link.group !== 'Agendamento' ? (
                  <NavigatorTab
                    id={`nav-link-${index + 1}`}
                    key={`navlink-${index + 1}`}
                    isLast={false}
                    isFirst={true}
                    {...link}
                  />
                ) : (
                  <></>
                )
              ) : (
                link.group !== 'Agendamento' && (
                  <NavigatorTab
                    id={`nav-link-${index + 1}`}
                    key={`navlink-${index + 1}`}
                    isLast={false}
                    isFirst={true}
                    {...link}
                  />
                )
              )}
            </>
          </>
        ))}
      </HStack>
    </Box>
  )
}

export default LayoutNavigator
